import React, { useEffect } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { addPageNumber } from '../common/addPageNumber';

interface Props {
    data: any;
    setPdfBlob: (blob: Blob) => void;
    formData?: any;
}

// Times arrive as "HH:mm" from the API; the rest of the reports show 12 hour.
const to12Hour = (time: string | null | undefined): string => {
    if (!time || time === '-') return '-';
    const [rawHours, minutes] = time.split(':');
    let hours = parseInt(rawHours, 10);
    if (isNaN(hours)) return '-';
    const suffix = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${hours}:${minutes} ${suffix}`;
};

const AdminClockReportPdf: React.FC<Props> = ({ data, setPdfBlob, formData }) => {
    const generatePDF = () => {
        const doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });

        doc.setFontSize(14);
        doc.text('Manual attendance by admin', 14, 15);

        // The range asked for, so a printed copy says what it covers.
        const from = formData?.StartDate ? moment(formData.StartDate).format('MM/DD/YYYY') : null;
        const to = formData?.EndDate ? moment(formData.EndDate).format('MM/DD/YYYY') : null;
        doc.setFontSize(9);
        doc.text(
            from || to ? `Dates recorded: ${from ?? 'any'} to ${to ?? 'any'}` : 'All dates',
            14,
            21
        );

        const rows: any[] = Array.isArray(data) ? data : [];

        autoTable(doc, {
            head: [[
                'Date',
                'Site',
                'Last Name',
                'First Name',
                'Position',
                'Action',
                'Time',
                'Time Source',
                'Recorded By',
                'Recorded At',
            ]],
            body: rows.map((r: any) => [
                r?.Date ?? '',
                r?.SiteName ?? '',
                r?.LastName ?? '',
                r?.FirstName ?? '',
                r?.Position ?? '',
                r?.Action ?? '',
                to12Hour(r?.RecordedTime),
                r?.TimeSource ?? '',
                r?.PerformedBy ?? '',
                r?.PerformedAt ?? '',
            ]),
            startY: 26,
            theme: 'grid',
            styles: { fontSize: 7, cellPadding: 1.5 },
            headStyles: { fontSize: 7, fontStyle: 'bold' },
        });

        addPageNumber(doc);

        setPdfBlob(doc.output('blob'));
    };

    useEffect(() => {
        if (data) {
            generatePDF();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return null;
};

export default AdminClockReportPdf;
